AuthInterceptor = ($q, $location, flash, returnUrl) ->
  saveReturnUrl = ->
    if $location.path() is '/session/new'
      returnUrl.url = '/'
    else
      returnUrl.url = $location.path()

  response: (response) ->
    response || $q.when(response)
  responseError: (rejection) ->
    switch
      when rejection.status is 401
        saveReturnUrl()
        localStorage.removeItem("isSignedIn")
        $location.path('/session/new')
        return rejection
    $q.reject rejection

AuthInterceptor.$inject = [
  '$q'
  '$location'
  'flash'
  'returnUrl'
]

module.exports = AuthInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/auth/auth-interceptor.coffee